module.exports = __webpack_public_path__ + "img/9.c071a7c8.jpg";